var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarouselArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "carousel-arrow-right_svg__lucide carousel-arrow-right_svg__lucide-arrow-right"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 12h14M12 5l7 7-7 7"
})));
export { SvgCarouselArrowRight as ReactComponent };
export default __webpack_public_path__ + "ec518ec573cb2baa03cbd068abc61178.svg";